var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64645 11.377C3.84171 11.5723 4.15829 11.5723 4.35355 11.377L7.53553 8.19505C7.7308 7.99979 7.7308 7.6832 7.53553 7.48794C7.34027 7.29268 7.02369 7.29268 6.82843 7.48794L4 10.3164L1.17157 7.48794C0.976311 7.29268 0.659728 7.29268 0.464466 7.48794C0.269204 7.6832 0.269204 7.99979 0.464466 8.19505L3.64645 11.377ZM4 0L3.5 0V11.0235H4H4.5V0L4 0Z",
    fill: "#E61D0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.3b28254b8fe29eb7705ec85663da987f.svg";
export { ForwardRef as ReactComponent };